import { Formik, Form, Field, ErrorMessage } from "formik";
import { useSearchParams } from "react-router-dom";
import { unsubscribe } from "../API/ApiService";
import { useEffect, useState } from "react";


export default function UnsubscribeComponent() {

    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");
    const [success, setSuccess] = useState("Loading");
    const [message, setMessage] = useState("");


    function validate(values) {
        const errors = {}
        if (!values.email.includes("@")) {
            errors.email = "Enter a valid email."
        }
       
        return errors;
    }

async function onSubmit(values, {resetForm}) {
    if (!token) {setSuccess("No token"); return;}

    try {
        const request = {email: values.email, token: token};

        const response = await unsubscribe(request);
        setMessage(response.data)
        setSuccess("Success");
        resetForm();
    } catch (error) {
        setSuccess("Error");
    }

}
        

    if (success === "Success" || success==="Error") {
        return (<div className="unsubscribeouter">
            <h4 className="unsubscribetitle">{message}</h4>
        </div>);
    }

    if (success === "No token") {
        return <div>No token.</div>;
    }



    return (
        <div className="unsubscribeouter">
                <h4 className="unsubscribetitle">Enter your email below to unsubscribe from notifications.</h4>

            <Formik
                initialValues={{email: ""}}
                validate={validate}
                onSubmit={onSubmit}
                validateOnBlur={false}
                validateOnChange={false}>

            { () => (
                <Form className="unsubscribeform" style={{marginStart: '0px', marginEnd: '0px'}}>
                    <ErrorMessage name="email" component="div" className="alert alert-warning"/>
            <div className="col-8">
                    <label>Email address: </label>
                    <Field className="unsubscribeemail" data-dashlane-disabled-on-field="true" data-form-type="other"
                    name="email" type="email"
                    placeholder="you@example.com"                   
                    ></Field>
                </div>
                <div>
                    <button type="submit" className="unsubscribebutton">Submit</button>
                </div>
                </Form> ) }
            </Formik>
        </div>
    )


}


